module.exports = __webpack_public_path__ + "img/ring_r_s_null_1@2x.58b53745.png";